import React from 'react';
import { Check } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { vehicles } from '../data/mock';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';

const Vehicles = () => {
  const { t } = useLanguage();

  const getVehicleData = (vehicleType) => {
    return t.vehicles[vehicleType];
  };

  return (
    <section id="vehicles" className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t.vehicles.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t.vehicles.subtitle}
          </p>
        </div>

        {/* Vehicles Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {vehicles.map((vehicle) => {
            const vehicleData = getVehicleData(vehicle.type);
            return (
              <Card 
                key={vehicle.id} 
                className="overflow-hidden hover:shadow-2xl transition-all duration-300 hover:scale-105 border-2 border-gray-200 hover:border-[#0077FF]"
              >
                {/* Vehicle Image */}
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={vehicle.image}
                    alt={vehicleData.name}
                    className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
                  />
                  <div className="absolute top-4 right-4">
                    <Badge className="bg-[#FF8C00] text-white font-bold px-3 py-1 text-sm">
                      {vehicle.priceFormatted}
                    </Badge>
                  </div>
                </div>

                <CardHeader>
                  <CardTitle className="text-2xl font-bold text-gray-900">
                    {vehicleData.name}
                  </CardTitle>
                  <CardDescription className="text-sm font-semibold text-[#0077FF] mt-1">
                    {vehicleData.models}
                  </CardDescription>
                  <CardDescription className="text-gray-600 mt-2">
                    {vehicleData.description}
                  </CardDescription>
                </CardHeader>

                <CardContent>
                  <ul className="space-y-2">
                    {vehicleData.features.map((feature, index) => (
                      <li key={index} className="flex items-start space-x-2">
                        <Check className="w-5 h-5 text-[#0077FF] mt-0.5 flex-shrink-0" />
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>

                <CardFooter>
                  <Button 
                    className="w-full bg-gradient-to-r from-[#0077FF] to-[#0055CC] hover:from-[#0055CC] hover:to-[#0077FF] text-white font-semibold py-6 md:py-4 text-base md:text-sm"
                    onClick={() => {
                      const element = document.getElementById('contact');
                      if (element) element.scrollIntoView({ behavior: 'smooth' });
                    }}
                  >
                    {t.vehicles.learnMore}
                  </Button>
                </CardFooter>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Vehicles;
